import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "../sidebar/components/Sidebar";
import { useSidebarStore } from "../../stores/sidebarStore";
import { isConfigured as isBedrockConfigured } from "../../services/bedrockService";

const Layout = ({ children }) => {
  const { isCollapsed } = useSidebarStore();
  const [useDemo, setUseDemo] = useState(() => !isBedrockConfigured());
  const [isDark, setIsDark] = useState(() => {
    if (typeof window !== "undefined") {
      const savedTheme = localStorage.getItem("theme");
      // 다크 테마를 기본값으로 (저장된 값이 없거나 dark인 경우)
      return savedTheme !== "light";
    }
    return true; // 기본값: 다크 테마
  });

  // Theme toggle
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", isDark ? "dark" : "light");
    localStorage.setItem("theme", isDark ? "dark" : "light");
  }, [isDark]);

  // Check API configuration
  useEffect(() => {
    setUseDemo(!isBedrockConfigured());
  }, []);

  return (
    <div className="flex h-screen bg-bg-100 text-text-100">
      {/* Sidebar - 전체 높이 */}
      <Sidebar />

      {/* Main Area with Header */}
      <div className="flex flex-col flex-1 overflow-hidden">
        {/* Header */}
        <Header
          isDark={isDark}
          setIsDark={setIsDark}
        />

        {/* Main Content */}
        <main className="flex-1 flex flex-col overflow-hidden">
          {children || <Outlet context={{ useDemo, setUseDemo }} />}
        </main>
      </div>
    </div>
  );
};

export default Layout;
